<app-header></app-header>
<div class="principal-container">
  <div class="banner-container row">
    <!-- <div class="left-side col-md-6 col-sm-12">
      <img
        mat-card-image
        src="../../../../assets/images/infoverses-experiencia.png"
        class="img-experiencia"
      />
    </div>
    <div class="right-side col-md-6 col-sm-12">
      <img
        mat-card-image
        src="../../../../assets/images/infoverses-admin.png"
        class="img-admin"
      />
      <div class="venta">
            <div class="categoria-noticia">Venta</div>
            <div class="triangulo-venta"></div>
          </div>
          <div class="title-noticia">
            ¡AHORRA HASTA UN 80% DE DESCUENTO DURANTE NUESTRA VENTA DE TOM
            CLANCY!
          </div>
          <div class="desc-noticia">
            Sumérgete en nuestro títulos tácticos más atrevidos
          </div>
          <button
            mat-button
            class="btn btn-comprar-plan"
            (click)="goToPlanes()"
          >
            Comprar plan
          </button>
          <div class="terminos">
            Válido en títulos seleccionados. La oferta finaliza el 18 de Julio
            de 2022 a las 2pm UTC.
          </div>
    </div> -->
  </div>
  <div class="second-container">
    <h1 class="principal-title">Mis eventos</h1>
    <div class="opciones"></div>
  </div>

  <div class="options-container">
    <div class="eventos-container">
      <div class="cards-container">
        <div class="tutorial">
          <a
            class="ver-tutorial"
            href="https://www.youtube.com/watch?v=JPCxIKkCTBI&list=PLszwZZhTuzzsX8wXtykvKWDB_gIDOf_c0"
            target="_blank"
            rel="noopener noreferrer"
            style="margin-top: 10px;"
          >
            Ver tutoriales
          </a>
        </div>
        <div class="row">
          <div class="first-row" id="f-row">
            <div class="col">
              <div
                class="textos crear-evento"
                (click)="openMarketplaceEventModal()"
              >
                <div class="title-crear">Crear marketplace</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="textos crear-evento" (click)="openFeriaEventModal()">
                <div class="title-crear">Crear feria de negocios</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div
                class="textos crear-evento"
                (click)="openConferenciaEventModal()"
              >
                <div class="title-crear">Crear conferencia</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div
                class="textos crear-evento"
                (click)="openFeriaEscolarEventModal()"
              >
                <div class="title-crear">Crear feria escolar</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div
                class="textos crear-evento"
                (click)="openYincanaEventModal()"
              >
                <div class="title-crear">Crear aventura de realidad aumentada</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <div
                class="textos crear-evento"
                (click)="openFeriaPersonalizadaEventModal()"
              >
                <div class="title-crear">Crear mundo personalizado</div>
                <div class="icono-crear-container">
                  <img
                    src="../../../../assets/images/add-icon.png"
                    alt=""
                    class="icon-crear"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="second-row" id="f-row2" *ngIf="marketplaces || ferias">
            <p class="title-option-evento1">
              Eventos creados
            </p>
            <div class="todos-container">
              <u></u>
            </div>
            <div class="line-events"></div>
          </div>

          <div class="col" *ngFor="let m of marketplaces">
            <div
              class="textos"
              [ngClass]="{ 'fondo-gris': m.desactivado_marketplace == 'Si' }"
            >
              <img
                mat-card-image
                src="../../../../assets/images/marketplaces.png"
                class="img-event"
              />
              <div class="event-name">
                {{ truncateText(m.nombre_marketplace) }}
              </div>
              <div class="icono">
                <button
                  class="btn btn-success"
                  (click)="visitEvent(m.id_marketplace, 'marketplace')"
                  [disabled]="m.desactivado_marketplace == 'Si'"
                >
                  Visitar
                </button>
                <button
                  class="btn btn-success editar"
                  (click)="editEvent(m.id_marketplace, 'marketplace')"
                  [disabled]="m.desactivado_marketplace == 'Si'"
                >
                  Editar
                </button>
                <button
                  class="btn btn-success"
                  (click)="goToStats(m)"
                  [disabled]="m.desactivado_marketplace == 'Si'"
                >
                  <mat-icon>leaderboard</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col" *ngFor="let f of ferias">
            <div
              class="textos"
              [ngClass]="{ 'fondo-gris': f.desactivado_feria == 'Si' }"
            >
              <img
                *ngIf="f.tipo_feria == 'educativa'"
                mat-card-image
                src="../../../../assets/images/Imagen-escolar.JPG"
                class="img-event"
              />
              <img
                *ngIf="f.tipo_feria == 'personalizada'"
                mat-card-image
                src="../../../../assets/images/ferias.png"
                class="img-event"
              />
              <img
                *ngIf="f.tipo_feria !== 'educativa' && f.tipo_feria !== 'personalizada'"
                mat-card-image
                src="../../../../assets/images/ferias-new.png"
                class="img-event"
              />
              <div class="event-name">
                {{ truncateText(f.nombre_feria) }}
              </div>
              <div class="icono">
                <button
                  class="btn btn-success"
                  (click)="visitEvent(f.id_feria, 'feria', f.tipo_feria)"
                  [disabled]="f.desactivado_feria == 'Si'"
                >
                  Visitar
                </button>
                <button
                  class="btn btn-success editar"
                  (click)="editEvent(f.id_feria, 'feria')"
                  [disabled]="f.desactivado_feria == 'Si'"
                >
                  Editar
                </button>
                <button
                  class="btn btn-success"
                  (click)="goToStats(f)"
                  [disabled]="f.desactivado_feria == 'Si'"
                >
                  <mat-icon>leaderboard</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="col" *ngFor="let y of yincanas">
            <div
              class="textos"
              [ngClass]="{ 'fondo-gris': y.desactivado_yinkana == 'Si' }"
            >
              <img
                mat-card-image
                src="../../../../assets/images/imagen-yincana.jpg"
                class="img-event"
              />
              <div class="event-name">
                {{ truncateText(y.nombre_yinkana) }}
              </div>
              <div class="icono">
                <button
                  class="btn btn-success"
                  (click)="visitEvent(y.id_yinkana, 'yinkana')"
                  [disabled]="y.desactivado_yinkana == 'Si'"
                >
                  Visitar
                </button>
                <button
                  class="btn btn-success editar"
                  (click)="editEvent(y.id_yinkana, 'yinkana')"
                  [disabled]="y.desactivado_yinkana == 'Si'"
                >
                  Editar
                </button>
                <button
                  class="btn btn-success"
                  (click)="goToStats(y)"
                  [disabled]="y.desactivado_yinkana == 'Si'"
                >
                  <mat-icon>leaderboard</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <p class="title-option-evento1">
        Historial
      </p>
      <div class="todos-container" (click)="goToMisEventos()">
        <u>
          Ver todos
        </u>
      </div>
      <div class="line-events"></div> -->
    </div>
  </div>
</div>
<app-footer></app-footer>
